<div class="wrapper h-100">
    <div class="main-panel">
        <app-navbar-noauth></app-navbar-noauth>
        <main>
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
